"use client";
import {
  switch_default
} from "./chunk-JK2N2KWJ.mjs";
import {
  useSwitch
} from "./chunk-VOHVN7KC.mjs";
export {
  switch_default as Switch,
  useSwitch
};
